import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import {QueryClient, QueryClientProvider} from 'react-query';
import {RouterProvider} from 'react-router-dom';
import {routes} from './routes';
import {ToastContainer} from 'react-toastify';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './styles/global.scss';
import {AuthProvider} from 'context/authContext';
import {Provider} from 'react-redux';
import {store} from 'store/redux';

const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      retry: false,
    },
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={routes} />
      </AuthProvider>
      <ToastContainer position="top-center" className="text-right" />
    </QueryClientProvider>
  </Provider>,
  // </React.StrictMode>,
);
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
